import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScrollingModule } from '@angular/cdk/scrolling';

import { CoreModule } from '@core/core.module';
import { SharedModule } from '@shared/shared.module';
import { NotesModule } from '@notes/notes.module';
import { ProjectRoutingModule } from './project-routing.module';
import { IConfig, NgxMaskDirective, NgxMaskPipe, provideEnvironmentNgxMask } from 'ngx-mask';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { RouterModule } from '@angular/router';
import { CarrierFullProfileModule } from '../carrier-full-profile/carrier-full-profile.module';
import { UploadCsvModule } from '../upload-csv/upload-csv.module';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';

import { ProjectDetailsComponent } from './project-details/project-details.component';

import { ProjectsIconComponent } from './projects-icon/projects-icon.component';
import { ProjectActionsComponent } from './project-actions/project-actions.component';
import { RecommendedCarriersComponent } from './recommended-carriers/recommended-carriers.component';

import { PannelHeaderComponent } from './capacity-search-panel/capacity-search-pannel/pannel-header/pannel-header.component';
import { PannelWrapperComponent } from './capacity-search-panel/capacity-search-pannel/pannel-wrapper/pannel-wrapper.component';
import { PannelBodyComponent } from './capacity-search-panel/capacity-search-pannel/pannel-body/pannel-body.component';
import {
	CarrierDataFeedbackComponent,
	CarrierDataFeedbackDialog,
} from './capacity-search-panel/carrier-data-feedback/carrier-data-feedback.component';
import { CapacitySearchFilterComponent } from './capacity-search-panel/capacity-search-filter/capacity-search-filter.component';

import { CoreTasksModule } from '../broker/tasks/core-tasks/core-tasks.module';
import { CarrierFeedbackModule } from '../carrier-feedback/carrier-feedback.module';
import { ContactDetailsModule } from '../contact-details/contact-details.module';
import {
	ExportCallListComponent,
	ExportCallListDialog,
} from './export-call-list/export-call-list.component';
import { LastBidDialogComponent } from './last-bid-dialog/last-bid-dialog.component';
import { MaxBuyDialogComponent } from './max-buy-dialog/max-buy-dialog.component';

import { LoadFormModule } from '../load-form/load-form.module';
import { ProjectSpecificationsComponent } from './project-details/project-specifications/project-specifications.component';
import { ProcuredCarriersComponent } from './procured-carriers/procured-carriers.component';

import { NgDragDropModule } from 'ng-drag-drop';
import { QuillModule } from 'ngx-quill';
import { MtxPopoverModule } from '@ng-matero/extensions/popover';
import { StickybitsModule } from 'ngx-stickybits';

import { PushModule } from '@ngrx/component';

import { StoreModule } from '@ngrx/store';
import { reducers } from './store/reducers';
import { EffectsModule } from '@ngrx/effects';
import { ProjectDetailsEffects } from './store/effects/project-details.effects';
import { RecommendedCarriersEffects } from './store/effects/recommended-carriers.effects';
import { ProjectCarrierMapEffects } from './store/effects/project-carrier-map.effects';
import { ProjectGroupEffects } from './store/effects/project-group.effects';
import { projectDetailsPageStateKey } from './store/state';
import { EngageCarriersDialogComponent } from './engage-carriers-dialog/engage-carriers-dialog.component';
import { ProjectGroupDialogComponent } from './project-group-dialog/project-group-dialog.component';
import { ProjectGroupsComponent } from './project-groups/project-groups.component';
import { AddToGroupComponent } from './add-to-group/add-to-group.component';
import { PricingHelperService } from '@service/pricing-helper/pricing-helper.service';
import { SelectProjectGroupComponent } from './select-project-group/select-project-group.component';

const maskConfig: Partial<IConfig> = {};

const components = [
	ProjectDetailsComponent,
	ProjectsIconComponent,
	RecommendedCarriersComponent,
	PannelHeaderComponent,
	PannelWrapperComponent,
	PannelBodyComponent,
	CapacitySearchFilterComponent,
	CarrierDataFeedbackComponent,
	CarrierDataFeedbackDialog,
	ExportCallListComponent,
	ExportCallListDialog,
	ProjectActionsComponent,
	LastBidDialogComponent,
	MaxBuyDialogComponent,
	ProjectSpecificationsComponent,
	ProcuredCarriersComponent,
];

@NgModule({
	declarations: [
		components,
		EngageCarriersDialogComponent,
		ProjectGroupDialogComponent,
		ProjectGroupsComponent,
		AddToGroupComponent,
		SelectProjectGroupComponent,
	],
	imports: [
		CommonModule,
		CoreModule,
		SharedModule,
		ProjectRoutingModule,
		NotesModule,
		NgxMaterialTimepickerModule,
		RouterModule,
		CarrierFullProfileModule,
		UploadCsvModule,
		MatTabsModule,
		CoreTasksModule,
		CarrierFeedbackModule,
		ContactDetailsModule,
		LoadFormModule,
		NgDragDropModule.forRoot(),
		QuillModule,
		MtxPopoverModule,
		StickybitsModule,
		StoreModule.forFeature(projectDetailsPageStateKey, reducers),
		EffectsModule.forFeature([
			ProjectDetailsEffects,
			RecommendedCarriersEffects,
			ProjectCarrierMapEffects,
			ProjectGroupEffects,
		]),
		NgxMaskDirective,
		NgxMaskPipe,
		PushModule,
		ScrollingModule,
	],
	exports: [...components],
	providers: [PricingHelperService, provideEnvironmentNgxMask(maskConfig)],
})
export class ProjectModule {}
